const companies = ['Azərenerji', 'SOCAR', 'Kapital Bank', 'ABB', 'Pasha Bank', 'Azercell', 'Bakcell', 'Nar Mobile'];

export default function LogoStrip() {
  const { t } = useTranslation();
  return (
    <section className="py-12 bg-white border-y border-slate-100 overflow-hidden">
      <p className="text-center text-xs font-semibold text-slate-400 tracking-widest uppercase mb-6">{t('home.logos_label')}</p>
      <div className="flex">
        <div className="flex gap-12 animate-marquee whitespace-nowrap">
          {[...companies, ...companies].map((name, i) => (
            <div key={i} className="flex items-center justify-center px-6 py-2 bg-slate-50 rounded-lg border border-slate-200 min-w-[140px]">
              <span className="text-slate-400 font-semibold text-sm">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
